import { useCallback, useState } from 'react';

export function useBoolean(
  initial?: boolean | (() => boolean)
): [boolean, () => void, () => void, () => void] {
  const [value, setValue] = useState(initial ?? false);
  const toggleValue = useCallback(() => setValue(value => !value), []);
  const toTrue = useCallback(() => setValue(() => true), []);
  const toFalse = useCallback(() => setValue(() => false), []);

  return [value, toggleValue, toTrue, toFalse];
}
